import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as React from 'react';
import TooltipRC from 'rc-tooltip';
import classNames from 'classnames';
import Conditional from '../misc/Conditional/index.js';
var Tooltip = function Tooltip(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "dark" : _ref$color,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? false : _ref$desc,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "top" : _ref$placement,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? false : _ref$title,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? ["hover"] : _ref$trigger,
    _ref$tooltipContainer = _ref.tooltipContainer,
    tooltipContainer = _ref$tooltipContainer === void 0 ? "body" : _ref$tooltipContainer,
    customButton = _ref.customButton;
  var tooltipClasses = classNames(_defineProperty(_defineProperty({}, "iq-tooltip--color-".concat(color), !!color), "iq-tooltip--placement-".concat(placement), !!placement));
  var tooltipQuestionClasses = classNames("iq-tooltip__question", _defineProperty({}, "iq-tooltip__question--".concat(color), !!color));
  var Balloon = function Balloon() {
    return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Conditional, {
      condition: !!title,
      renderIf: /* @__PURE__ */React.createElement("h2", {
        className: "iq-tooltip__title"
      }, title)
    }), /* @__PURE__ */React.createElement(Conditional, {
      condition: !!desc,
      renderIf: /* @__PURE__ */React.createElement("p", {
        className: "iq-tooltip__desc"
      }, desc)
    }));
  };
  return /* @__PURE__ */React.createElement(TooltipRC, {
    placement: placement,
    trigger: trigger,
    overlay: Balloon,
    prefixCls: "iq-tooltip",
    overlayClassName: tooltipClasses,
    getTooltipContainer: function getTooltipContainer() {
      return document.querySelector(tooltipContainer);
    }
  }, customButton ? customButton : /* @__PURE__ */React.createElement("span", {
    className: tooltipQuestionClasses
  }, "?"));
};
export { Tooltip as default };